import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";

export default function SoftwareSkill({softwareSkills}) {
  const list = Array.isArray(softwareSkills)
    ? softwareSkills
    : skillsSection.softwareSkills;

  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {list.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                <i className={skills.fontAwesomeClassname}></i>
                <p>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
